module.exports = __webpack_public_path__ + "static/ART_LOGO_Primary-d55c001397feb1e9d973d9089ea29420.svg";